










































































import { EmployerUser, FetchState, Permission } from "@/shared/types";
import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import * as _ from "lodash";
import Pill from "@/shared/components/ui/Pill.vue";
import ManageEmployerUserForm from "@/shared/components/ManageEmployerUserForm.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployerUserStore } from "@/shared/store/employerUser";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useRoleStore } from "@/shared/store/role";

const UnknownErrorMessage = "Error processing your request. Please try again later";

@Component({
  components: {
    Pill,
    ManageEmployerUserForm
  },
})
export default class ManageEmployers extends Vue {
  notifierStore = useNotifierStore();
  employerUserStore = useEmployerUserStore();
  roleStore = useRoleStore();
  rolePermissionsStore = useRolePermissionsStore();

  updatingRoles = false;
  showEditUserInfoModal = false;
  selectedEmployerUser: EmployerUser = null;
  selectedActionPanelUserId: number = null;

  roles = [];

  @Prop()
  employerId: number;

  get securityGroupsOptions () {
    return this.roleStore.employerRoles.map(role => ({text: role.displayName ? role.displayName : role.roleName, value: role.roleId}));
  }

  created (): void {
    this.employerUserStore.getEmployerUsers(this.employerId)
      .then(resp => {
        this.$emit("loaded");
      })
      .catch(this.handleError);
    this.roleStore.getEmployerRoles();
  }

  sendActivationLink (user: any): void {
    if (user.invitationSent) {
      return;
    }
    this.employerUserStore.resendEmployerUserSignupLink({ userId: user.userId, employerId: this.employerId })
      .then(resp => {
        this.notifierStore.setSuccess("Invitation link has been resent successfully!");
        this.closeActionsPanel();
      })
      .catch(this.handleError);
  }

  deleteUser (userId: number): void {
    this.employerUserStore.deleteEmployerUser({ userId, employerId: this.employerId })
      .then(resp => {
        this.notifierStore.setSuccess("User has been sucessfully removed!");
        this.closeActionsPanel();
      })
      .catch(this.handleError);
  }

  handleError (err): void {
    this.notifierStore.setDanger(err.errorMessage || UnknownErrorMessage);
  }

  openActionsPanel (event, employerUser: EmployerUser): void {
    event.preventDefault();

    // if the panel is already selected, close the panel
    // otherwise select the user to display the summary
    if (employerUser.userId === this.selectedActionPanelUserId) {
      this.closeActionsPanel();
    } else {
      this.selectedActionPanelUserId = employerUser.userId;
    }
  }

  closeActionsPanel (): void {
    this.selectedActionPanelUserId = null;
  }

  openEditEmployerUserModal (employerUser: EmployerUser): void {
    this.selectedEmployerUser = employerUser;
    this.$root.$emit("bv::toggle::modal", "employer-user-edit-modal", "#modal-toggle");
  }

  get hasManageUserWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.ManageUsersWrite);
  }

  get disableRoleEdit (): boolean {
    return !this.hasManageUserWritePermission || this.updatingRoles;
  }

  getPillClass (employerUser: EmployerUser): string {
    if (employerUser.isConfirmed) {
      return "success-pill";
    }

    return "neutral-pill";
  }

  getPillText (employerUser: EmployerUser): string {
    if (employerUser.isConfirmed) {
      return "Active";
    }

    return "Pending";
  }

  onSecurityInput (user: EmployerUser, selectedRoles: string[]) {
    if (this.updatingRoles) {
      return;
    }

    const allRoles = _.union(selectedRoles, user.roles);
    if (selectedRoles.length === user.roles.length && allRoles.length === selectedRoles.length) {
      return;
    }

    this.updatingRoles = true;

    this.employerUserStore.changeEmployerUserRoles({
      employerUserId: user.employerUserId,
      employerId: this.employerId,
      userRoles: selectedRoles
    })
      .finally(() => this.updatingRoles = false);
  }
}
